import _defineProperty from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { jsx as t } from "react/jsx-runtime";
import i from "classnames";
import { Component as e } from "react";
var n = {
  animating: "rah-animating",
  animatingUp: "rah-animating--up",
  animatingDown: "rah-animating--down",
  animatingToHeightZero: "rah-animating--to-height-zero",
  animatingToHeightAuto: "rah-animating--to-height-auto",
  animatingToHeightSpecific: "rah-animating--to-height-specific",
  static: "rah-static",
  staticHeightZero: "rah-static--height-zero",
  staticHeightAuto: "rah-static--height-auto",
  staticHeightSpecific: "rah-static--height-specific"
};
function a(t) {
  t.forEach(function (t) {
    return cancelAnimationFrame(t);
  });
}
var s = /*#__PURE__*/function (_e) {
  _inherits(s, _e);
  function s(t) {
    var _this;
    _classCallCheck(this, s);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(s).call(this, t)), _this.animationFrameIDs = [];
    var i = t.height;
    _this.state = {
      animationStateClasses: {},
      height: i,
      overflow: null
    };
    return _this;
  }
  _createClass(s, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var t = this;
      var i = this.props.opened;
      i ? this.contentElement.style.display = "" : this.contentDisplay = setTimeout(function () {
        t.contentElement.style.display = "none";
      }, 330), this.animationStateClasses = Object.assign({}, n), this.setState(function (i) {
        return {
          animationStateClasses: t.getStaticStateClasses(i.height)
        };
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(t, e) {
      var n = this;
      var _this$props = this.props,
        s = _this$props.height,
        o = _this$props.opened;
      o && this.contentDisplay && (clearTimeout(this.contentDisplay), this.contentDisplay = null);
      var h = "auto" === e.height;
      if (this.contentElement && s !== t.height) {
        this.showContent(e.height), this.contentElement.style.overflow = "hidden";
        var _o = this.contentElement.offsetHeight;
        this.contentElement.style.overflow = "";
        var l = null;
        var m = {
          height: null,
          overflow: "hidden"
        };
        0 === s ? (l = s, m.height = l) : (l = _o, m.height = "auto", m.overflow = null), h && (m.height = l, l = _o);
        var c = i(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, this.animationStateClasses.animating, !0), this.animationStateClasses.animatingUp, "auto" === t.height || s < t.height), this.animationStateClasses.animatingDown, "auto" === s || s > t.height), this.animationStateClasses.animatingToHeightZero, 0 === m.height), this.animationStateClasses.animatingToHeightAuto, "auto" === m.height)),
          r = this.getStaticStateClasses(m.height);
        this.setState({
          animationStateClasses: c,
          height: l,
          overflow: "hidden"
        }), clearTimeout(this.timeoutID), clearTimeout(this.animationClassesTimeoutID), h ? (a(this.animationFrameIDs), this.animationFrameIDs = function (t) {
          var i = [];
          return i[0] = requestAnimationFrame(function () {
            i[1] = requestAnimationFrame(function () {
              t();
            });
          }), i;
        }(function () {
          n.setState(m);
        }), this.animationClassesTimeoutID = setTimeout(function () {
          n.setState({
            animationStateClasses: r
          }), n.hideContent(m.height);
        }, 330)) : this.timeoutID = setTimeout(function () {
          m.animationStateClasses = r, n.setState(m), "auto" !== s && n.hideContent(l);
        }, 330);
      }
      t.opened !== o && o && h && (this.overflowTimeoutId = setTimeout(function () {
        n.setState({
          overflow: "visible"
        });
      }, 0)), t.opened !== o && (o ? this.contentElement.removeAttribute("inert") : this.contentElement.setAttribute("inert", ""));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      a(this.animationFrameIDs), clearTimeout(this.timeoutID), clearTimeout(this.animationClassesTimeoutID), clearTimeout(this.overflowTimeoutId), clearTimeout(this.contentDisplay), this.timeoutID = null, this.animationClassesTimeoutID = null, this.overflowTimeoutId = null, this.contentDisplay = null;
    }
  }, {
    key: "getStaticStateClasses",
    value: function getStaticStateClasses(t) {
      return i(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, this.animationStateClasses.static, !0), this.animationStateClasses.staticHeightZero, 0 === t), this.animationStateClasses.staticHeightSpecific, t > 0), this.animationStateClasses.staticHeightAuto, "auto" === t));
    }
  }, {
    key: "hideContent",
    value: function hideContent(t) {
      0 === t && (this.contentElement.style.display = "none");
    }
  }, {
    key: "showContent",
    value: function showContent(t) {
      0 === t && (this.contentElement.style.display = "");
    }
  }, {
    key: "render",
    value: function render() {
      var e = this;
      var n = this.props.children,
        _this$state = this.state,
        a = _this$state.height,
        s = _this$state.animationStateClasses,
        o = {
          height: a,
          overflow: this.state.overflow,
          transition: "height 330ms linear"
        },
        h = {
          transition: "opacity 330ms linear"
        };
      0 === a && (h.opacity = 0);
      var l = i(_defineProperty(_defineProperty({}, s, !0), "VDS__", !0));
      return t("div", {
        "aria-hidden": 0 === a,
        className: l,
        style: o,
        children: t("div", {
          style: h,
          ref: function ref(t) {
            t && (e.contentElement = t);
          },
          children: n
        })
      });
    }
  }]);
  return s;
}(e);
export { s as default };